export * from './Observacion.nav';